module.exports = "<svg id=\"dcfdb308-78f5-42ba-a803-9b78935e84de\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>phone</title><rect width=\"50\" height=\"50\"></rect><path d=\"M16.94,28l-5.41,6.85a.36.36,0,0,0,.06.5h0l4.12,3.3a4.06,4.06,0,0,0,5.66-.6,81,81,0,0,0,7.46-10.81,80,80,0,0,0,5.63-11.87,4,4,0,0,0-2.31-5.19L27.23,8.31a.36.36,0,0,0-.47.21h0l-3.23,8.11a.36.36,0,0,0,.2.47h0l2.76,1.07c-.93,2-2,4-3.1,6l0,0C22.25,26.11,21,28,19.77,29.82L17.46,28A.36.36,0,0,0,17,28v0Zm10.36-9.9h0Z\" style=\"fill: #fff;fill-rule: evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/phone.svg
// module id = 513
// module chunks = 1